import { DataProxy } from 'apollo-cache';
import produce, { Draft } from 'immer';

import {
  ClientDisclosureFragment,
  ClientDisclosureStatus,
  ClientProtectedFragment,
  ClientProtectedFragmentDoc,
} from 'api';

interface IReducer {
  cache: DataProxy;
  client_id: ClientProtectedFragment['id'];
  result: ClientDisclosureFragment;
}

interface IReducers {
  updateDisclosureOnClient: (
    fragment: ClientProtectedFragment,
    result: ClientDisclosureFragment,
  ) => ClientProtectedFragment;
}

const reducers: IReducers = {
  updateDisclosureOnClient: produce((fragment: Draft<ClientProtectedFragment>, result) => {
    const isEnabled = result.disclosure_status === ClientDisclosureStatus.Active;
    const existingIndex = fragment.disclosures.findIndex(disclosure => disclosure.id === result.id);

    if (existingIndex < 0 && isEnabled) {
      fragment.disclosures.unshift({
        ...result,
        __typename: 'ClientDisclosure',
      });

      return fragment;
    }

    if (existingIndex >= 0 && isEnabled) {
      fragment.disclosures[existingIndex] = result;
      return fragment;
    }

    if (existingIndex >= 0 && !isEnabled) {
      fragment.disclosures.splice(existingIndex, 1);
      return fragment;
    }

    return fragment;
  }),
};

export default (options: IReducer) => {
  const { cache, client_id, result } = options;

  const clientFragment: ClientProtectedFragment = cache.readFragment({
    id: `Client:${client_id}`,
    fragment: ClientProtectedFragmentDoc,
    fragmentName: 'ClientProtected',
  });

  if (!clientFragment) {
    return;
  }

  cache.writeFragment({
    id: `Client:${client_id}`,
    fragment: ClientProtectedFragmentDoc,
    fragmentName: 'ClientProtected',
    data: reducers.updateDisclosureOnClient(clientFragment, result),
  });
};
